import _ from 'lodash';
import { useMemo } from 'react';

import { AutoAwesomeOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import {
  StockAnalysisSectionCode,
  useStockAnalysisModalQuery
} from 'generated/graphql';
import { useSendStockAnalysisMessage } from 'modules/components/layer45/ChatPane/dataService';



export type StockAnalysisButtonProps = {
  variant?: 'chat';
  companyId: string;
  sectionCode?: StockAnalysisSectionCode;
};

export const FC = ({
  variant, companyId, sectionCode
}: StockAnalysisButtonProps) => {
  const {
    data,
    loading
  } = useStockAnalysisModalQuery({
    variables: {
      listedCompanyId: companyId
    }
  });

  const buttonText = useMemo(() => {
    if (sectionCode) {
      const sectionAnalysis = data?.listedCompany?.stockAnalysis.find((sa) => sa.sectionCode === sectionCode);
      const sectionTitle = sectionAnalysis?.title;
      return sectionTitle ?? _.startCase(sectionCode);
    }

    return 'Investment Case';
  }, [
    data?.listedCompany?.stockAnalysis,
    sectionCode
  ]);

  const [fnSendStockAnalysisMessage] = useSendStockAnalysisMessage();

  const hasStockAnalysis = useMemo(
    () => !_.isEmpty((data?.listedCompany?.stockAnalysis ?? [])),
    [data?.listedCompany?.stockAnalysis]
  );

  const sx = variant !== 'chat' ? {
    backgroundColor: '#D4AF37',
    boxShadow: '#D4AF37 0px 2px 2px 0px'
  } : {
    backgroundColor: '#D4AF37',
    boxShadow: '#D4AF37 0px 2px 2px 0px',
    height: '40px',
    borderRadius: '8px'
  };

  return (
    <Button
      disabled={loading || !hasStockAnalysis}
      size='small'
      variant='contained'
      sx={sx}
      endIcon={!loading && <AutoAwesomeOutlined fontSize='small' />}
      onClick={(() => {
        if (sectionCode) {
          fnSendStockAnalysisMessage({
            listedCompanyId: companyId, stockAnalysisSectionCode: sectionCode
          });
        } else {
          window.open(`/company/${companyId}/investmentCase`, '_blank');
        }
      })}
    >
      {loading ? 'Retrieving...' : buttonText}
    </Button>
  );
};
